// templates/component/Registration.js
import React from 'react'
import { FoundationsButton } from '../../GenericComponents/button'
import { FoundationsInput } from '../../GenericComponents/input'
import { FoundationsCheckBox } from '../../GenericComponents/checkbox'
import { FoundationsConstants } from '../../FoundationsConstants'
import { useEffect, useState } from 'react'
import { appSettingsType } from '../../Types/appSettings'
import { useForm } from 'react-hook-form'
import { FoundationsForm } from '../../GenericComponents/form'
import { FormValidation } from '../../FormValidationsRules'
import { FoundationsAlert } from '../../GenericComponents/alert'
// import { useNavigate } from 'react-router-dom'
import { FoundationsEnums } from '../../enum'
import { UserType } from '../../Types/userType'
import { RegistrationFormData, useSubmitFormMutation } from '../../Redux/Register/registerSlice'
import FoundationsSelect from '../../GenericComponents/select'
import { useSelector, useStore, useDispatch } from 'react-redux'
import { Skeleton } from '../../GenericComponents/Skeleton'
import { passwordValidate } from '../../Utils'
import { encryptData, getCurrentCookiePath, redirectHome, setCookie } from '../../GlobalMethods'
import Cookies from 'js-cookie'
import { getCurrentUserData, getAppSettings, RootState } from '../../Redux/store'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import store, {  setAppRedirectURL, setAppWorkflowState } from "../../Redux/store";
import { appWorkflowStates } from '../../Types/appWorkflowStates';
import { useTitleContext } from "../../Hooks/useTitleContext";
import { useLazyGetSSOLoginQuery } from '../../Redux/SSOSignIn/SSOSignInSlice';
import { useLocation } from 'react-router-dom';

declare let window: any
const UnicornApp = window.unicornInstance as any

// const {
//     availableRoles,
//     displayNTPSectionOfRegisterForm,
//     availableLocations
//   } = this.options.appSettings..attributes;

function Registration() {
    const ssoUserInfo: RegistrationFormData = JSON.parse(
        Cookies.get(FoundationsConstants.NEW_USER) || '{}'
    )
    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        formState: { errors, isValid, isSubmitted },
    } = useForm()

    const [firstName, setFirstName] = useState(ssoUserInfo?.FirstName || '')
    const [lastName, setLastName] = useState(ssoUserInfo?.LastName || '')
    const [email, setEmail] = useState(ssoUserInfo?.EmailAddress || '')
    const [password, setPassword] = useState('') // TODO => SSO password handling here
    const [confirmPassword, setConfirmPassword] = useState('') // TODO => SSO password handling here
    const [responseMessage, setResponseMessage] = useState('')
    const [userStatus, setUserStatus] = useState('')
    const [statusCode, setStatusCode] = useState(0)
    const [termsAgreed, setTermsAgreed] = useState(false)
    //const [appSettings, setAppSettings] = useState({} as appSettingsType)
    const [Submitted, setSubmitted] = useState(false)
    const [registerUser] = useSubmitFormMutation()
    const [domain, setDomain] = useState('')
    const [siteCode, setSiteCode] = useState('-1')
    const [roleSelect, setRoleSelect] = useState('')
    const [nationalProviderID, setNationalProviderID] = useState('')
    const [loading, setLoading] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const store = useStore()
    const location = useLocation();
    const [openIdLoading, setOpenIdLoading] = useState(false)
    const [requestSent, setRequestSent] = useState(false)

    const [triggerSSOLogin, { isFetching }] = useLazyGetSSOLoginQuery();
    
    const handleSSO = async () => {
        try {
            const result = await triggerSSOLogin().unwrap();
            const authRequest = result?.data;

            if (
                authRequest?.OpenIdLoginURL &&
                authRequest?.OpenIdRedirectURL &&
                authRequest?.scope &&
                authRequest?.client_id &&
                authRequest?.state
            ) {
                const openIDURL =
                    authRequest.OpenIdLoginURL +
                    authRequest.OpenIdRedirectURL +
                    "&scope=" +
                    authRequest.scope +
                    "&client_id=" +
                    authRequest.client_id +
                    "&state=" +
                    authRequest.state;
                window.location.href = openIDURL;
            } else {
                console.error("Malformed SSO response:", authRequest);
            }
            setCookie(FoundationsConstants.OPENID_STATE, authRequest.state, 10 * 60);
        } catch (err: any) {
            const message = err?.data?.hints || err?.data?.statusMessage || 'SSO login failed';
            console.error('SSO Error:', message);
        }
    };

    const dispatch = useDispatch()

    const { setTitle } = useTitleContext();
    setTitle("Register");

    const currentUserData = useSelector(
        (state: RootState) => getCurrentUserData(state)
      )
      const appSettings: any = useSelector(
        (state: RootState) => { return getAppSettings(state) || {} }
      )
    const passwordsMatch = (val: string) => {
        if (watch('Password') != val) {
            return 'Your password and confirm password do not match.'
        } else {
            return true
        }
    }
 Cookies.remove(FoundationsConstants.NEW_USER, {path: getCurrentCookiePath()});
  
    useEffect(() => {
        setLoading(false)
                if (currentUserData?.AccountInfo) {
                    dispatch(setAppRedirectURL(redirectHome(currentUserData)))
                    dispatch(setAppWorkflowState(appWorkflowStates.FORCE_REDIRECT))  
                }
    }, [])

    // Add reset form function
    const resetForm = () => {
        setFirstName('');
        setLastName('');
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        setResponseMessage('');
        setUserStatus('');
        setStatusCode(0);
        setTermsAgreed(false);
        setDomain('');
        setSiteCode('-1');
        setRoleSelect('');
        setNationalProviderID('');
        setSubmitted(false);
        clearErrors(); 
        
    };
    
    useEffect(() => {
        if (location.hash === '#register') {
            resetForm();
        }
    }, [location.hash]);
    useEffect(() => {
    // Add event listener for form reset
    const handleResetForm = () => {
        resetForm();
        };

        window.addEventListener('resetRegistrationForm', handleResetForm);

        // Cleanup
        return () => {
            window.removeEventListener('resetRegistrationForm', handleResetForm);
        };
    }, []);

    const submitRegistration = async () => {

        setIsSubmitting(true); //FP-10689: Disable button after first click to prevent multiple submissions
        setResponseMessage('');
        try {
            const requestUserInfo = {
                FirstName: firstName,
                LastName: lastName,
                EmailAddress: email,
                Password: encryptData(password,appSettings.PublicEncryptionKey),
                ReenterPassword: encryptData(confirmPassword,appSettings.PublicEncryptionKey),
                secId: ssoUserInfo?.secId ? ssoUserInfo.secId : null,
                samAccountName: ssoUserInfo?.samAccountName ? ssoUserInfo.samAccountName : null,
                RoleId: roleSelect,
                NationalProviderID: nationalProviderID,
                AgreeTOS: termsAgreed,
                DomainSlashUserid: domain,
                authSource: ssoUserInfo?.EmailAddress
                    ? FoundationsEnums.Authentication.OpenID
                    : FoundationsEnums.Authentication.Foundations,
                OrganizationName:
                    appSettings.availableLocations?.find((loc:any) => loc.id + '' == siteCode)?.location ||
                    ' ',
                SiteCode: siteCode,
            };

            const response = await registerUser(requestUserInfo).unwrap();
            if (response != null) {
                const resultData = response.data;
                if (resultData != null && resultData.MessageResults.length > 0) {
                    resultData.MessageResults.forEach(
                        (msg: { HelpMessage: FoundationsEnums.Status; Message: any }) => {
                            setResponseMessage(msg.Message);
                            setUserStatus(response.data.userStatus);
                            setSubmitted(true);
                        }
                    );
                } else {
                    FoundationsGenericToaster('error', 'Something went wrong');
                }
            }
        } 
        catch (request) 
        {
            const errorResponse = request as { responseJSON: { hints?: string; statusMessage?: string } };
            setResponseMessage(
                errorResponse.responseJSON?.hints ?? errorResponse.responseJSON?.statusMessage ?? ''
            );
            setTermsAgreed(true);
            setSubmitted(false);
        } 
        finally 
        {
            setIsSubmitting(false); // Reset the submission state after completion
        }

        //TODO example of how to handle loading state
        // let content

        // if (isLoading) {
        //   content = <Spinner text="Loading..." />
        // } else if (isSuccess) {
        //   content = posts.map(post => <PostExcerpt key={post.id} post={post} />)
        // } else if (isError) {
        //   content = <div>{error.toString()}</div>
        // }

        // TODO!!!! ->
        //requestUserInfo.OrganizationName = '';
        // let OrganizationName = $("#primary_site_select").children("option").filter(":selected").text();
        // requestUserInfo.OrganizationName = OrganizationName;

        // requestUserInfo.NationalProviderID = '';
        // requestUserInfo.SiteCode = this.primary_site_select.val();

        // if (appSettings['displayNTPSectionOfRegisterForm']) {
        //   requestUserInfo.DomainSlashUserid = this.domain_input.val();
        //   //requestUserInfo.OrganizationName = this.organisation_input.val();
        //   requestUserInfo.NationalProviderID = this.national_input.val();
        // }

        var triggerEvents = {
            EndedSuccesfully: 'registerView:FetchEnded',
            EndedWithFailure: 'registerView:FetchError',
            Started: 'registerView:FetchStarted',
        }

        // FoundationsRequest('POST', {
        //     triggerEvents: triggerEvents,
        //     url: getBaseUrl() + 'API/v3/Account',
        //     cache: false,
        //     data: JSON.stringify(requestUserInfo),
        //     success: function (
        //         response: {
        //             data: {
        //                 MessageResults: any
        //                 userStatus: any
        //             }
        //         } | null
        //     ) {
        //         if (response != null) {
        //             var resultData = response.data
        //             if (
        //                 resultData != null &&
        //                 resultData.MessageResults.length > 0
        //             ) {
        //                 resultData.MessageResults.forEach(
        //                     (msg: {
        //                         HelpMessage: FoundationsEnums.Status
        //                         Message: any
        //                     }) => {
        //                         setResponseMessage(msg.Message)
        //                         setUserStatus(response.data.userStatus)
        //                         setSubmitted(true)
        //                     }
        //                 )
        //             } else {
        //                 UnicornApp.toastr('error', 'Something went wrong')
        //             }
        //         }
        //     },
        //     error: function (
        //         request: {
        //             responseJSON: {
        //                 hints: React.SetStateAction<string>
        //                 statusMessage: React.SetStateAction<string>
        //             }
        //         },
        //         err: any
        //     ) {
        //         setResponseMessage(
        //             request.responseJSON?.hints
        //                 ? request.responseJSON.hints
        //                 : request.responseJSON?.statusMessage
        //         )
        //         setTermsAgreed(true)
        //         setSubmitted(false)
        //     },
        // })
    }

    return (
        <>
            {Submitted ? (
                <RegistrationSuccess UserStatus={userStatus} statusMessage={responseMessage} />
            ) : (
                <span className={'Registration'} data-testid="Registration">
                    <div className="row">
                        <div className="mx-auto offset-lg-2 col-lg-10" id="register_form_el">
                            <div className="row">
                                <div className="col-md-8 col-lg-9 col-xl-8">
                                    <div className="col-12 text-left px-0 mb-3">
                                    </div>
                                    <FoundationsForm
                                        id="register_form"
                                        submitFunction={submitRegistration}
                                        handleSubmit={handleSubmit}
                                    >
                                        <div className="col-12" id="status_message">
                                            {statusCode === 401 && responseMessage !== '' ? (
                                                <FoundationsAlert
                                                    id="register_status"
                                                    type="error"
                                                    message={responseMessage}
                                                ></FoundationsAlert>
                                            ) : (
                                                <></>
                                            )}
                                        </div>

                                        <div className="col-12 text-left px-0 mb-3">
                                            <div className="header">Register</div>
                                            {/* need to follow this standard format of naming data-automation-id page-name_component-unique-name_role-of-element */}
                                            <div data-automation-id = "registration-sso-sub-header" className="sub-header padding-top-small">
                                                Sign up to Foundations
                                            </div>

                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8 px-0">
                                                        <FoundationsButton
                                                            id="button_openid_signin"
                                                            buttonClasses="app-button openid_signin_button m-3"
                                                            type="button"
                                                            loaderClasses="app-account-loading w-90"
                                                            isLoading={openIdLoading}
                                                            disabled={isFetching}
                                                            onClick={handleSSO}
                                                        >
                                                            Sign Up with OpenID
                                                        </FoundationsButton>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="connected-divider">
                                                <span>OR</span>
                                            </div>

                                            <div data-automation-id = "registration-form-sub-header" className="sub-header padding-top-small">
                                                Sign up to create a new Foundations account.
                                            </div>
                                        </div>

                                        <>
                                            <div className="col-12">
                                                <Skeleton
                                                    loading={loading}
                                                    className="register-input1"
                                                >
                                                    <FoundationsInput
                                                        classes="form-group mb-3 row"
                                                        value={firstName}
                                                        onInput={(e: {
                                                            target: { value: string }
                                                        }) => {
                                                            setFirstName(e.target?.value)
                                                        }}
                                                        id="first_name"
                                                        name="first_name"
                                                        type="text"
                                                        containerClasses="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8"
                                                        maxLength={50}
                                                        labelText="First Name:"
                                                        labelClasses="col-lg-2 col-xl-3 text-left"
                                                        errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                                        disabled={appSettings.isSSO}
                                                        ariaAutocomplete="none"
                                                        autocomplete="off"
                                                        registerFunction={register}
                                                        registerName="FirstName"
                                                        registerRules={FormValidation.first_name} //todo add validation
                                                        error={errors.FirstName?.message}
                                                    ></FoundationsInput>
                                                </Skeleton>
                                            </div>
                                            <div className="col-12">
                                                <Skeleton
                                                    loading={loading}
                                                    className="register-inputs"
                                                >
                                                    <FoundationsInput
                                                        classes="form-group mb-3 row"
                                                        value={lastName}
                                                        onInput={(e: {
                                                            target: { value: string }
                                                        }) => {
                                                            setLastName(e.target?.value)
                                                        }}
                                                        id="last_name"
                                                        name="last_name"
                                                        type="text"
                                                        containerClasses="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8"
                                                        maxLength={50}
                                                        labelText="Last Name:"
                                                        labelClasses="col-lg-2 col-xl-3 text-left"
                                                        errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                                        ariaAutocomplete="none"
                                                        autocomplete="off"
                                                        disabled={appSettings.isSSO}
                                                        registerFunction={register}
                                                        registerName="LastName"
                                                        registerRules={FormValidation.last_name}
                                                        error={errors.LastName?.message}
                                                    ></FoundationsInput>
                                                </Skeleton>
                                            </div>
                                            <div className="col-12">
                                                <Skeleton
                                                    loading={loading}
                                                    className="register-inputs"
                                                >
                                                    <FoundationsInput
                                                        classes="form-group mb-3 row"
                                                        value={email}
                                                        onInput={(e: {
                                                            target: { value: string }
                                                        }) => {
                                                            setEmail(e.target?.value)
                                                        }}
                                                        id="user_email"
                                                        name="user_email"
                                                        type="text"
                                                        containerClasses="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8"
                                                        maxLength={50}
                                                        labelText="Email:"
                                                        labelClasses="col-lg-2 col-xl-3 text-left"
                                                        errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                                        ariaAutocomplete="none"
                                                        autocomplete="off"
                                                        disabled={appSettings.isSSO}
                                                        registerFunction={register}
                                                        registerName="Email"
                                                        toolTipText="Email should be of the format: name@company.domain"
                                                        tooltipClasses="tooltip-icons ml-2"
                                                        registerRules={FormValidation.email}
                                                        error={errors.Email?.message}
                                                    ></FoundationsInput>
                                                </Skeleton>
                                            </div>

                                            {!appSettings.isSSO ? (
                                                <>
                                                    <div className="col-12">
                                                        <Skeleton
                                                            loading={loading}
                                                            className="register-inputs"
                                                        >
                                                            <FoundationsInput
                                                                classes="form-group mb-3 row"
                                                                value={password}
                                                                onInput={(e: {
                                                                    target: {
                                                                        value: string
                                                                    }
                                                                }) => {
                                                                    setPassword(e.target?.value)
                                                                }}
                                                                id="password_input"
                                                                name="password_input"
                                                                type="password"
                                                                containerClasses="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8"
                                                                maxLength={24}
                                                                labelText="Password:"
                                                                labelClasses="col-lg-2 col-xl-3 text-left"
                                                                errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                                                ariaAutocomplete="none"
                                                                autocomplete="off"
                                                                disabled={appSettings.isSSO}
                                                                registerFunction={register}
                                                                registerName="Password"
                                                                toolTipText="Password: Must be at least 8 letters. Must have at least one uppercase letter. Must have at least one lowercase letter. Must have at least one number. Must have at least one special character from ~!@#$%^&amp;*(),.+;:?/"
                                                                tooltipClasses="tooltip-icons ml-2"
                                                                registerRules={{
                                                                    ...FormValidation.registerPassword,
                                                                    validate: (val: string) => passwordValidate(val, firstName, lastName),
                                                                }}
                                                                error={errors.Password?.message}
                                                            ></FoundationsInput>
                                                        </Skeleton>
                                                    </div>
                                                    <div className="col-12">
                                                        <Skeleton
                                                            loading={loading}
                                                            className="register-inputs"
                                                        >
                                                            <FoundationsInput
                                                                classes="form-group mb-3 row"
                                                                value={confirmPassword}
                                                                onInput={(e: {
                                                                    target: {
                                                                        value: string
                                                                    }
                                                                }) => {
                                                                    setConfirmPassword(
                                                                        e.target?.value
                                                                    )
                                                                }}
                                                                id="confirm_password_input"
                                                                name="confirm_password_input"
                                                                type="password"
                                                                containerClasses="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8"
                                                                maxLength={24}
                                                                labelText="Confirm Password:"
                                                                labelClasses="col-lg-2 col-xl-3 text-left"
                                                                errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                                                ariaAutocomplete="none"
                                                                autocomplete="off"
                                                                disabled={appSettings.isSSO}
                                                                registerFunction={register}
                                                                registerName="ConfirmPassword"
                                                                registerRules={{
                                                                    ...FormValidation.confirmPassword,
                                                                    validate: passwordsMatch,
                                                                }}
                                                                error={
                                                                    errors.ConfirmPassword?.message
                                                                }
                                                            ></FoundationsInput>
                                                        </Skeleton>
                                                    </div>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                            {/* {appSettings..displayNTPSectionOfRegisterForm ? (
                                            <> */}
                                            <div className="col-12"></div>
                                            <div className="col-12">
                                                <Skeleton
                                                    loading={loading}
                                                    className="register-inputs"
                                                >
                                                    <FoundationsSelect
                                                        id="primary_role_select"
                                                        classes="form-group mb-3 row"
                                                        value={roleSelect}
                                                        onChange={(e: {
                                                            target: {
                                                                value: string
                                                            }
                                                        }) => {
                                                            setRoleSelect(e.target?.value)
                                                        }}
                                                        name="primary_role"
                                                        containerClasses="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8"
                                                        selectClasses="w-100"
                                                        errorClasses="col-sm-12 offset-md-2 col-md-10"
                                                        labelText="Primary Role:"
                                                        labelClasses="col-lg-2 col-xl-3 text-left"
                                                        optional={false}
                                                        toolTipText="Your primary role in your organization or hospital"
                                                        tooltipClasses="tooltip-icons ml-2"
                                                        registerFunction={register}
                                                        registerName="PrimaryRole"
                                                        registerRules={FormValidation.primary_role} //todo add validation
                                                        error={errors.PrimaryRole?.message}
                                                    >
                                                        {appSettings.availableRoles == undefined ||
                                                        appSettings.availableRoles == null ||
                                                        appSettings.availableRoles.length === 0 ? (
                                                            <option value="">-</option>
                                                        ) : (
                                                            <>
                                                                <option value="">
                                                                    - select a role -
                                                                </option>
                                                                {appSettings.availableRoles.map(
                                                                    (role : any) => (
                                                                        !role.IsRestricted && <option key={role.id} value={role.id}>
                                                                            {role.displayName}
                                                                        </option>
                                                                    )
                                                                )}
                                                            </>
                                                        )}
                                                    </FoundationsSelect>
                                                </Skeleton>
                                            </div>
                                            <div className="col-12 ">
                                                <Skeleton
                                                    loading={loading}
                                                    className="register-inputs"
                                                >
                                                    <FoundationsSelect
                                                        id="primary_site_select"
                                                        classes="form-group mb-1 row"
                                                        name="primary_site"
                                                        value={siteCode}
                                                        onChange={(e: {
                                                            target: {
                                                                value: string
                                                            }
                                                        }) => {
                                                            setSiteCode(e.target?.value)
                                                        }}
                                                        selectClasses="w-100"
                                                        containerClasses="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8"
                                                        errorClasses="col-sm-12 offset-md-2 col-md-10"
                                                        labelText="Primary Site Code / Name:"
                                                        labelClasses="col-lg-2 col-xl-3 text-left"
                                                        toolTipText="Your VA Medical Center Location."
                                                        tooltipClasses="tooltip-icons ml-2"
                                                        optional={
                                                            ssoUserInfo?.EmailAddress ===
                                                                undefined ||
                                                            ssoUserInfo?.EmailAddress === null
                                                        }
                                                    >
                                                        <option value="-1">
                                                            - select a location -
                                                        </option>
                                                        {appSettings.availableLocations ? (
                                                            appSettings.availableLocations.map(
                                                                (location : any) => (
                                                                    <option key={location.id} value={location.id}>
                                                                        {location.location}
                                                                    </option>
                                                                )
                                                            )
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </FoundationsSelect>
                                                </Skeleton>
                                            </div>
                                            <div className="col-12">
                                                <Skeleton
                                                    loading={loading}
                                                    className="register-inputs"
                                                >
                                                    <FoundationsInput
                                                        classes="form-group mb-3 row"
                                                        id="domain_input"
                                                        type="text"
                                                        name="domain"
                                                        value={domain}
                                                        onInput={(e: {
                                                            target: {
                                                                value: string
                                                            }
                                                        }) => {
                                                            setDomain(e.target?.value)
                                                        }}
                                                        labelText="Domain Login:"
                                                        containerClasses="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8"
                                                        maxLength={200}
                                                        labelClasses="col-lg-2 col-xl-3 text-left col-form-label"
                                                        errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                                        loaderClasses="col-lg-2 col-xl-3 text-left"
                                                        optional={true}
                                                        toolTipText="Domain UserId should be of this format: domain\username"
                                                        tooltipClasses="tooltip-icons ml-2"
                                                    ></FoundationsInput>
                                                </Skeleton>
                                            </div>
                                            <div className="col-12">
                                                <Skeleton
                                                    loading={loading}
                                                    className="register-inputs"
                                                >
                                                    <FoundationsInput
                                                        classes="form-group mb-3 row"
                                                        id="national_input"
                                                        type="text"
                                                        name="national"
                                                        value={nationalProviderID}
                                                        onInput={(e: {
                                                            target: {
                                                                value: string
                                                            }
                                                        }) => {
                                                            setNationalProviderID(e.target?.value)
                                                        }}
                                                        containerClasses="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8"
                                                        labelText="National Provider ID:"
                                                        maxLength={30}
                                                        errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                                        labelClasses="col-lg-2 col-xl-3 text-left col-form-label"
                                                        optional={true}
                                                        toolTipText="Your National Provider Identifier (NPI)."
                                                        tooltipClasses="tooltip-icons ml-2"
                                                        registerFunction={register}
                                                        registerName="NationalProviderID"
                                                        registerRules={FormValidation.Settings.NationalProviderID}
                                                        error={errors.NationalProviderID?.message}
                                                    ></FoundationsInput>
                                                </Skeleton>
                                            </div>
                                        </>
                                        <div className="col-12 "></div>
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-3 m-t-15">
                                                    Terms of Service:
                                                </div>
                                                <div className="col-9 m-t-15 text-left">
                                                    <div className="row">
                                                        <div className="col-12 m-b-15 px-0">
                                                            <div className="m-b-15">
                                                                {' '}
                                                                Please review the summary of Terms
                                                                of Service below.
                                                            </div>
                                                            <div></div>
                                                            <div className="terms-of-service-summary small text-left">
                                                                {' '}
                                                                By using HealthLevel software, you
                                                                are agreeing (in summary):
                                                                <ul className="ol-decimal-tos">
                                                                    <li className="text-left">
                                                                        That you will not disclose
                                                                        the software functions with
                                                                        others.
                                                                    </li>
                                                                    <li className="text-left">
                                                                        {' '}
                                                                        You will not share passwords
                                                                        and account access with
                                                                        other people.
                                                                    </li>
                                                                    <li className="text-left">
                                                                        {' '}
                                                                        You will take reasonable
                                                                        care to prevent others from
                                                                        peering over your shoulder.
                                                                    </li>
                                                                    <li className="text-left">
                                                                        {' '}
                                                                        Any feedback you give will
                                                                        be used to improve the
                                                                        product and serve you
                                                                        better.
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div className="padding-top-large text-left">
                                                                You can review the{' '}
                                                                <a
                                                                    id="link_tos"
                                                                    href="#terms"
                                                                    tabIndex={-1}
                                                                    target="_website"
                                                                >
                                                                    full EULA Legalese here
                                                                </a>
                                                                .
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 m-3">
                                            <div className="row pl-2 pl-md-5">
                                                <div className="col-12 ml-0 ml-md-5 pl-0 pl-md-5">
                                                    <FoundationsCheckBox
                                                        name="terms"
                                                        id="register_terms_checkbox"
                                                        value="accepted_terms"
                                                        classes="row"
                                                        containerClasses="row"
                                                        inputClasses="checkbox-height foundations-checkbox"
                                                        labelClasses="px-0 pl-2 cursor-pointer select-none"
                                                        labelText="I agree to the HealthLevel's Terms of Service"
                                                        registerFunction={register}
                                                        registerName={'TermsCheckbox'}
                                                        checked={termsAgreed}
                                                        onChange={() => {
                                                            setTermsAgreed(!termsAgreed)
                                                        }}
                                                        errorClasses="col-sm-12 offset-md-2 col-md-10"
                                                        error={errors.TermsCheckbox?.message}
                                                        htmlFor = {true}  // FP-10115_master Clicking on label should select the checkbox
                                                    />                                                 
                                                </div>
                                                <div className="col-9 text-left"></div>
                                            </div>
                                        </div>
                                        <div className="col-12"></div>
                                        <div className="col-12 text-left mt-3">
                                            <FoundationsButton
                                                classes="offset-lg-3 col-4 p-l-0 signin_button"
                                                id="button_register"
                                                buttonClasses="app-button"
                                                type="submit"
                                                disabled={!termsAgreed || isSubmitting}
                                                isLoading={loading}
                                                loaderClasses="app-account-loading"
                                            >
                                                Create My Account
                                            </FoundationsButton>
                                        </div>
                                    </FoundationsForm>
                                </div>
                                <div className="col-md-4 col-lg-3 col-xl-4 mt-5 mt-sm-0 border-top-responsive">
                                    <div className="main-right-container">
                                        <div className="content">
                                            <div className="header">Confirm Registration</div>
                                            <div>
                                                Haven't received your confirm registration email
                                                yet?
                                            </div>
                                            <div>
                                                Send{' '}
                                                <a
                                                    href="#send-email-confirmation"
                                                    id="ctl00_site_master_main_container_link_confirm_register_1"
                                                >
                                                    confirm registration email
                                                </a>{' '}
                                                to you again.
                                            </div>
                                        </div>
                                        <div className="padding-top-largest"></div>
                                        <div className="padding-top-largest"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>
            )}
        </>
    )
}

interface registrationSuccesProps {
    UserStatus: string
    statusMessage: string
}
function RegistrationSuccess(props: registrationSuccesProps) {
    return (
        <>
            <div className="row">
                <div className="col-8" id="register_confirmation_el">
                    <div className="row text-left">
                        <div className="col-12 mb-3">
                            <div className="header">Register</div>
                            {props.UserStatus === 'Registered' ? (
                                <div className="status-box-success">
                                    Registration successful. {props.statusMessage}
                                </div>
                            ) : (
                                <div className="status-box-success">
                                    Your current status is{' '}
                                    <span className="sub-header">{props.UserStatus}</span>.{' '}
                                    {props.statusMessage}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-4">
                    <div className="main-right-container">
                        <div className="content">
                            <div className="header">Sign In</div>
                            <div>
                                If you have an approved account,{' '}
                                <a
                                    href="#signin"
                                    id="ctl00_site_master_main_container_link_signin_1"
                                >
                                    sign in here
                                </a>
                                .
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Registration
